import React from 'react';
import QRCode from 'react-qr-code';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Icon, Label } from '@atlas/ui';

const QR_CODE_ERROR_CORRECTION_LEVEL = 'H';
const ZERO_WIDTH_SPACE = String.fromCharCode(0x200b);

const disableIosAutoDetection = code => (code ? code.split('').join(ZERO_WIDTH_SPACE) : code);

const PixDepositResultQRCard = ({
  formattedAmount,
  hasCopyButton,
  isCopied,
  isExpired,
  onCopy,
  pixCode,
}) => {
  const isCopiedAndActive = isCopied && !isExpired;

  const qrCodeClassName = cx({ 'pix-deposit-result__card-qr-expired': isExpired });
  const copyBtnClassName = cx('pix-deposit-result__card-copy-btn', {
    'pix-deposit-result__card-copy-btn-active': !isCopiedAndActive && !isExpired,
    'pix-deposit-result__card-copy-btn-copied': isCopiedAndActive,
    'pix-deposit-result__card-copy-btn-expired': isExpired,
  });

  return (
    <div className="pix-deposit-result__card-container">
      <div className="pix-deposit-result__card">
        <div className="pix-deposit-result__card-info">
          <div className="pix-deposit-result__card-amount">
            <Label className="pix-deposit-result__card-amount-label" message="deposit" />
            <span className="pix-deposit-result__card-amount-value">{formattedAmount}</span>
          </div>
          <div className="pix-deposit-result__card-code-wrapper">
            <span className="pix-deposit-result__card-code">
              {disableIosAutoDetection(pixCode)}
            </span>
          </div>
        </div>
        <div className="pix-deposit-result__card-qr-wrapper">
          <QRCode
            className={qrCodeClassName}
            level={QR_CODE_ERROR_CORRECTION_LEVEL}
            size={94}
            value={pixCode || ''}
          />
          {isExpired && (
            <>
              <div className="pix-deposit-result__card-qr-overlay" />
              <Icon className="pix-deposit-result__card-qr-lock" name="lock" />
            </>
          )}
        </div>
        {hasCopyButton && (
          <button
            className={copyBtnClassName}
            disabled={isCopied || isExpired}
            onClick={onCopy}
            type="button"
          >
            {isCopiedAndActive && (
              <Icon className="pix-deposit-result__card-copy-btn-icon" name="done" />
            )}
            <Label message={isCopiedAndActive ? 'copied_pix_code' : 'copy_pix_code'} />
          </button>
        )}
      </div>
    </div>
  );
};

PixDepositResultQRCard.propTypes = {
  formattedAmount: PropTypes.string.isRequired,
  hasCopyButton: PropTypes.bool,
  isCopied: PropTypes.bool.isRequired,
  isExpired: PropTypes.bool.isRequired,
  onCopy: PropTypes.func,
  pixCode: PropTypes.string,
};

export default PixDepositResultQRCard;
